import {
  InputLabel,
  TableBody,
  TextField,
  Typography,
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "@material-ui/pickers";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import ButtonController from "components/request-document/components/ButtonController";
import {
  Bagde,
  StyledTableCell,
  useStyles,
} from "components/request-document/components/Commons";
import usePersonalDetail from "components/request-document/hooks/usePersonalDetail";
import useSmartForm from "components/request-document/hooks/useSmartForm";
import useSmartService from "components/request-document/hooks/useSmartService";
import useSmartSubName from "components/request-document/hooks/useSmartSubName";
import { useFormik } from "formik";
import {
  REQUEST_DOCUMENT_STEP,
  RoleId,
  STATUS_PROCESS,
} from "libs/configs/constant";
import { SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import { getErrorMessage } from "libs/utils/form";
import { get, isError } from "lodash-es";
import { React, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
  addSmartForm,
  addSmartFormSlice,
  getSmartFormFieldConfig,
  selectCurrentSmartForm,
  selectSmartFormFieldConfig,
} from "redux/modules/visaForm";
import * as yup from "yup";

export default function UserProfileStepC() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const subName = useSmartSubName();

  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);
  const canEdit = useSelector(canEditForm);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const smartform = useSelector(selectCurrentSmartForm);

  const { smartserviceId } = useSmartService();
  const { personalId } = usePersonalDetail();
  const { draftId, addSmartFormState, getSmartForm } = useSmartForm();

  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });

  const detailList = [
    "ProgramName",
    "AttendingFrom",
    "AttendingTo",
    "NameOfReference",
    "Position",
    "MobilePhone",
    "Email",
  ];
  const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
  const partfromId =
    defaultType.find((field) => field.partFromName === "Part B")?.partfromId ||
    "";
  const detail = get(smartform, "detail", [])
    .filter((field) => field.partfromId === partfromId)
    .filter((field) => detailList.includes(field.smartName))
    .reduce(smartNameById, {});

  useEffect(() => {
    if (smartserviceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId }));
      getSmartForm({
        smartserviceId,
        draftId,
        personalId,
      });
    }
  }, [dispatch, draftId, getSmartForm, personalId, smartserviceId]);

  useEffect(() => {
    if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());
        if (!isSaveDraft) {
          dispatch(setSmartFormStep(SMART_T_STEP.PART_E));
        } else {
          getSmartForm({
            smartserviceId,
            draftId,
            personalId,
          });
        }
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [
    addSmartFormState.error?.message,
    addSmartFormState.isFailure,
    addSmartFormState.isLoading,
    addSmartFormState.isSuccess,
    dispatch,
    draftId,
    getSmartForm,
    hideLoading,
    isSaveDraft,
    personalId,
    smartserviceId,
  ]);

  const callAPISubmit = async (values) => {
    showLoading();
    const { visaissuance, ...restValues } = values;
    const documentFields = Object.keys(restValues);
    const getFieldListConfig = defaultType
      .filter((field) => field.partfromId === partfromId)
      .filter((field) => documentFields.includes(field.smartName));

    const getValue = (field) => {
      switch (field.smartName) {
        default:
          return get(values, `${field.smartName}`, null);
      }
    };

    const getSmartId = (field) =>
      get(detail, `${field.smartName}.smartId`, null);

    const prepareData = {
      draftId: draftId || null,
      smartserviceId,
      personalId: personalId,
      survey: null,
      visaissuance: visaissuance,
      detail: getFieldListConfig.map((field) => ({
        smartName: field.smartName,
        smartId: getSmartId(field),
        partfromId: field.partfromId,
        configsmartId: field.configsmartId,
        linkTable: field.linkTable,
        value: getValue(field),
      })),
    };

    await dispatch(
      addSmartForm({
        data: prepareData,
      })
    );
  };

  const validationSchema = yup.object({});
  const isDraftDocument = smartform?.statausID === STATUS_PROCESS.Draft;
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: isDraftDocument ? validationSchema : yup.object({}),
    initialValues: {
      ProgramName: get(detail, "ProgramName.value", ""),
      AttendingFrom: get(detail, "AttendingFrom.value", ""),
      AttendingTo: get(detail, "AttendingTo.value", ""),
      NameOfReference: get(detail, "NameOfReference.value", ""),
      Position: get(detail, "Position.value", ""),
      MobilePhone: get(detail, "MobilePhone.value", ""),
      Email: get(detail, "Email.value", ""),
    },
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });
  const Role = useSelector((e) => {
    return e.user.profile.roleId;
  });
  // Disabled all field if status != draft
  if (!isDraftDocument && Role !== RoleId.Admin) {
    formik.handleBlur = () => {};
    formik.handleChange = () => {};
    formik.setFieldValue = () => {};
  }

  return (
    <div className={classes.root}>
      <form onSubmit={formik.handleSubmit}>
        <ContentTitle
          title="Application Form"
          subTitle={`APPLICATION FOR QUALIFICATION ENDORSEMENT FOR SMART VISA “S” ${subName}`}
        />
        <Steper currentStep={1} stepInfo={REQUEST_DOCUMENT_STEP} />
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={4}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    Part B : Program in which you have participated
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              <TableRow>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={1} />
                    <div className={classes.wrapField}>
                      <InputLabel>Program name</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="ProgramName"
                        value={formik.values.ProgramName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("ProgramName", formik)}
                        helperText={getErrorMessage("ProgramName", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={2} />
                    <div>
                      <InputLabel>
                        Attending period (dd-mn-yyyy to dd-mm-yyyy)
                      </InputLabel>
                      <div className={classes.flexRow}>
                        <DatePicker
                          disabled={!canEdit}
                          className={classes.formControl}
                          // style={{ width: 30 }}
                          inputVariant="outlined"
                          disableFuture={false}
                          openTo="year"
                          format="DD-MM-YYYY"
                          label="Start date"
                          views={["year", "month", "date"]}
                          name={`AttendingFrom`}
                          value={formik.values.AttendingFrom || null}
                          onChange={(date) => {
                            formik.setFieldValue(
                              `AttendingFrom`,
                              date.format("YYYY-MM-DD")
                            );
                          }}
                          error={isError(`AttendingFrom`, formik)}
                          helperText={getErrorMessage(`AttendingFrom`, formik)}
                        />
                        <DatePicker
                          disabled={!canEdit}
                          className={classes.formControl}
                          // style={{ width: 30 }}
                          inputVariant="outlined"
                          // disableFuture={false}
                          openTo="year"
                          format="DD-MM-YYYY"
                          label="End date"
                          views={["year", "month", "date"]}
                          name={`AttendingTo`}
                          value={formik.values.AttendingTo || null}
                          onChange={(date) => {
                            formik.setFieldValue(
                              `AttendingTo`,
                              date.format("YYYY-MM-DD")
                            );
                          }}
                          error={isError(`AttendingTo`, formik)}
                          helperText={getErrorMessage(`AttendingTo`, formik)}
                        />
                      </div>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={3} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Name of reference person or contact person at the
                        program
                      </InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="NameOfReference"
                        value={formik.values.NameOfReference}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("NameOfReference", formik)}
                        helperText={getErrorMessage("NameOfReference", formik)}
                        multiline
                        rows={5}
                        rowsMin={5}
                        rowsMax={5}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={4} />
                    <div className={classes.wrapField}>
                      <InputLabel>Position</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="Position"
                        value={formik.values.Position}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("Position", formik)}
                        helperText={getErrorMessage("Position", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={5} />
                    <div className={classes.wrapField}>
                      <InputLabel>Phone Number</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        // type="number"
                        variant="outlined"
                        className={classes.textField}
                        name="MobilePhone"
                        inputProps={{ maxLength: 10 }}
                        onKeyDown={(e) => {
                          const pattern = /[^0-9]/g;
                          const isNotAllow =
                            e.key.length === 1 && pattern.test(e.key);

                          if (isNotAllow) {
                            e.preventDefault();
                          }
                        }}
                        value={formik.values.MobilePhone}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("MobilePhone", formik)}
                        helperText={getErrorMessage("MobilePhone", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={6} />
                    <div className={classes.wrapField}>
                      <InputLabel>E-mail address</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="Email"
                        value={formik.values.Email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("Email", formik)}
                        helperText={getErrorMessage("Email", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <ButtonController
          onClickSaveDraft={() => {
            if (!canEdit) {
              dispatch(setSmartFormStep(SMART_T_STEP.PART_E));
              return;
            }
            setSaveDraft(true);
            callAPISubmit(formik.values);
          }}
        />
      </form>
    </div>
  );
}
